/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoMarketVehicleBoxRequest model module.
 * @module model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoMarketVehicleBoxRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoMarketVehicleBoxRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoMarketVehicleBoxRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoMarketVehicleBoxRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxRequest} The populated <code>PerplayStatisticsControllerDtoMarketVehicleBoxRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoMarketVehicleBoxRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = ApiClient.convertToType(data['boxType'], 'String');
            }
            if (data.hasOwnProperty('boxGrade')) {
                obj['boxGrade'] = ApiClient.convertToType(data['boxGrade'], 'String');
            }
            if (data.hasOwnProperty('isPlus')) {
                obj['isPlus'] = ApiClient.convertToType(data['isPlus'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoMarketVehicleBoxRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoMarketVehicleBoxRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoMarketVehicleBoxRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['boxType'] && !(typeof data['boxType'] === 'string' || data['boxType'] instanceof String)) {
            throw new Error("Expected the field `boxType` to be a primitive type in the JSON string but got " + data['boxType']);
        }
        // ensure the json data is a string
        if (data['boxGrade'] && !(typeof data['boxGrade'] === 'string' || data['boxGrade'] instanceof String)) {
            throw new Error("Expected the field `boxGrade` to be a primitive type in the JSON string but got " + data['boxGrade']);
        }

        return true;
    }


}

PerplayStatisticsControllerDtoMarketVehicleBoxRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoMarketVehicleBoxRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoMarketVehicleBoxRequest.prototype['endDate'] = undefined;

/**
 * @member {String} boxType
 */
PerplayStatisticsControllerDtoMarketVehicleBoxRequest.prototype['boxType'] = undefined;

/**
 * @member {String} boxGrade
 */
PerplayStatisticsControllerDtoMarketVehicleBoxRequest.prototype['boxGrade'] = undefined;

/**
 * @member {Boolean} isPlus
 */
PerplayStatisticsControllerDtoMarketVehicleBoxRequest.prototype['isPlus'] = undefined;






export default PerplayStatisticsControllerDtoMarketVehicleBoxRequest;

